module.exports = __webpack_public_path__ + "img/17865_L.812f0949.png";